import { computed } from 'mobx';

/**
 * 모델
 * @window w_tb_e042
 * @category 사전점검항목등록
 */
export class EarlyInspectionModel3 {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 종류
   *
   * **data type** varchar(2)
   */
  evcd: string;

  /**
   * 구분코드
   *
   * **data type** varchar(2)
   */
  gresultcd: string;

  /**
   * 구분코드
   *
   * **data type** varchar(2)
   */
  gresultnm: string;

  /**
   * 모름
   *
   * **data type** varchar(2)
   */
  resultcd: string;

  /**
   * 모름
   *
   * **data type** varchar(2)
   */
  resultnm: string;

  /**
   * No
   *
   * **data type** varchar(2)
   */
  seq: string;

  /**
   * 검사항목,장치
   *
   * **data type** varchar(2)
   */
  seqnm: string;

  /**
   * 허용오차
   *
   * **data type** varchar(100)
   */
  aa_error: string;

  /**
   * 모름
   *
   * **data type** varchar(1)
   */
  state: string;


  /**
   * 사용유무
   *
   * **data type** varchar(1)
   */
  useyn: string;

  /**
   * 비고
   *
   * **data type** text
   */
  remark: string;

  /**
   * 입력자
   *
   * **data type** varchar(10)
   */
  inperid: string;

  /**
   * 입력일
   *
   * **data type** varchar(8)
   */
  indate: string;

  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.evcd = data.evcd || '';
    this.gresultcd = data.gresultcd || '';
    this.gresultnm = data.gresultnm || '';
    this.resultcd = data.resultcd || '';
    this.resultnm = data.resultnm || '';
    this.seq = data.seq || '';
    this.seqnm = data.seqnm || '';
    this.aa_error = data.aa_error || '';
    this.state = data.state || '';
    this.useyn = data.useyn || '';
    this.remark = data.remark || '';
    this.inperid = data.inperid || '';
    this.indate = data.indate || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
